// js
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../common/Tooltip';


const DefaultLogSizeSelectorEditButton = ({ visible, onClick }) => {

  const tooltipText = `
    Changing the default log size will reset all of the
    estimated log size inputs for all of your configured items,
    which may result in data loss. Proceed with caution.
  `;

  const style = {
    display: visible ? 'inline-block' : 'none'
  };

  return (
    <div className='DefaultLogSizeSelectorEditButton' style={style}>
      <Tooltip text={tooltipText} position='top'>
        <a href='#' onClick={onClick}>Edit</a>
      </Tooltip>
    </div>
  );
};

DefaultLogSizeSelectorEditButton.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default DefaultLogSizeSelectorEditButton;



// WEBPACK FOOTER //
// ./src/components/sources/DefaultLogSizeSelectorEditButton.js